import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return(// <img src="/img/Closebutton.png" style={{height:'20px'}} alt="" />
    // <span className="arrowBg-close">
    /*#__PURE__*/ _jsx("span", {
        className: "",
        children: /*#__PURE__*/ _jsx("span", {
            className: "",
            children: "X"
        })
    }));
};
export default Icon;
